const LoginSVG: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      className="h-6 ltr:mr-2 rtl:ml-2"
    >
      <g fill="none" fillRule="evenodd">
        <g
          fill="currentColor"
          fillRule="nonzero"
          className="group-hover:text-gold-200"
        >
          <g>
            <g>
              <path
                d="M12.377 11.885c2.715-1.134 4.253-4.029 3.676-6.918C15.475 2.08 12.942 0 10 0 7.058 0 4.525 2.079 3.947 4.967c-.577 2.889.961 5.784 3.676 6.918C3.156 12.98.01 16.985 0 21.59v.248C0 23.03.967 24 2.16 24h15.68c1.193 0 2.16-.969 2.16-2.163v-.248c-.01-4.605-3.156-8.61-7.623-9.704zM5.679 6.168c0-2.39 1.935-4.327 4.321-4.327 2.386 0 4.321 1.938 4.321 4.327 0 2.39-1.935 4.327-4.321 4.327-2.386 0-4.321-1.937-4.321-4.327zm12.47 15.669c0 .17-.139.309-.31.309H2.16c-.17 0-.308-.139-.308-.31v-.247c0-4.506 3.648-8.158 8.148-8.158s8.148 3.652 8.148 8.158v.248z"
                transform="translate(-1046 -40) translate(1046 39.995) translate(0 .005)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default LoginSVG
